"use strict";

exports.__esModule = true;
exports.default = exports.Img = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _excluded = ["src", "alt", "loading", "ratio", "fit", "className", "isFullScreen", "onCloseFullScreen", "canExpand"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * The Img component enhances the img native element with lazy-loading and/or responsive-ratio.
 */
var Img = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  var src = props.src,
      alt = props.alt,
      loading = props.loading,
      ratio = props.ratio,
      fit = props.fit,
      className = props.className,
      isFullScreen = props.isFullScreen,
      onCloseFullScreen = props.onCloseFullScreen,
      canExpand = props.canExpand,
      attributes = _objectWithoutPropertiesLoose(props, _excluded);

  var _React$useState = _react.default.useState(isFullScreen || false),
      isFS = _React$useState[0],
      setFS = _React$useState[1];

  _react.default.useEffect(function () {
    return setFS(isFullScreen);
  }, [isFullScreen]);

  var handleFullScreen = function handleFullScreen(value) {
    if (typeof onCloseFullScreen === 'function') {
      onCloseFullScreen(value);
    } else {
      setFS(value);
    }
  };

  var containerClasses = (0, _clsx.default)('uk-img', ratio !== 'none' && 'uk-img--withRatio', ratio !== 'none' && "uk-img--" + fit, isFS && 'uk-img--fullscreen', className);
  var applyRatio = {};

  if (ratio !== 'none') {
    applyRatio.style = {
      paddingTop: 100 * ratio.split('/')[1] / ratio.split('/')[0] + "%"
    };
  }

  var applyLazy = {};

  if (loading === 'lazy') {
    applyLazy.loading = 'lazy';
  }

  return /*#__PURE__*/_react.default.createElement("div", _extends({
    className: containerClasses
  }, applyRatio, {
    ref: ref
  }), src ? /*#__PURE__*/_react.default.createElement("img", _extends({
    src: src,
    alt: alt
  }, applyLazy, attributes)) : /*#__PURE__*/_react.default.createElement("svg", {
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M16 20a3.08 3.08 0 01-.53 0L19 16.47a3.08 3.08 0 010 .53 3 3 0 01-3 3z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M28 11v12a3 3 0 01-3 3H9.42l4.47-4.47a5 5 0 006.64-6.64l2.54-2.54A1 1 0 0024 13a1 1 0 001-1 1 1 0 00-.65-.93l2.46-2.46A3 3 0 0128 11zM27.71 4.29a1 1 0 00-1.42 0L22.59 8H14a2 2 0 00-2-2h-2a2 2 0 00-2 2H7a3 3 0 00-3 3v12a3 3 0 001.2 2.39l-.91.9a.21.21 0 00-.06.08l-.07.07a1 1 0 001.55 1.27l22-22a1 1 0 000-1.42zM16.54 14a3.28 3.28 0 00-.54 0 3 3 0 00-3 3 3.29 3.29 0 000 .54l-1.51 1.56A4.8 4.8 0 0111 17a5 5 0 015-5 4.8 4.8 0 012.1.49z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M19 17a3 3 0 01-3 3 3.08 3.08 0 01-.53 0L19 16.47a3.08 3.08 0 010 .53z"
  })), canExpand && /*#__PURE__*/_react.default.createElement("button", {
    type: "button",
    className: "button--" + (isFS ? 'close' : 'expand'),
    onClick: function onClick() {
      return handleFullScreen(!isFS);
    }
  }, /*#__PURE__*/_react.default.createElement("i", {
    className: "fa fa-" + (isFS ? 'times' : 'arrows-alt')
  })));
});

exports.Img = Img;
Img.propTypes = {
  /**
   * Source of the Img
   */
  src: _propTypes.default.string,

  /**
   * Alt-text of the Img
   */
  alt: _propTypes.default.string,

  /**
   * Set loading strategy of the Img
   */
  loading: _propTypes.default.oneOf(['normal', 'lazy']),

  /**
   * Set Img's ratio to preserve
   */
  ratio: _propTypes.default.string,

  /**
   * Behavior of the Img (when ratio is set)
   */
  fit: _propTypes.default.oneOf(['cover', 'contain']),

  /**
   * Enable the fullscreen
   */
  canExpand: _propTypes.default.bool
};
Img.defaultProps = {
  src: null,
  loading: 'normal',
  ratio: 'none',
  fit: 'cover',
  canExpand: false,
  alt: null
};
var _default = Img;
exports.default = _default;